import { put, takeLatest } from "redux-saga/effects";
import { getListCampaignApi } from "store/api/SpecialOfferApi";
import { GET_LIST_CAMPAIGN_ACTION } from "../../actions/SpecialOfferPageAction/actionTypes";

import * as specialOfferPageAction from "../../actions/SpecialOfferPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getListCampaign(actions) {
	yield put(globalAction.openLoadingPage());
	const res = yield getListCampaignApi(actions?.params);
	try {
		if (res?.code === 0) {
			const data = res?.data;
			yield put(specialOfferPageAction.setListCampaignAction(data));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getListCampaignSaga() {
	yield takeLatest(GET_LIST_CAMPAIGN_ACTION, getListCampaign);
}

export default getListCampaignSaga;
